export enum KEY {
    ENTER = 'Enter',
    ESC = 27,
    SPACE = 32,
}
